import React from 'react';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { Jacket, Typography, Box } from '@drone-js/core';

const ActivityCardHighlightBanner: React.FC<{ isMobileScreen?: boolean }> = ({ isMobileScreen }) => {
    const cms = useSelector(selectCmsFromBootstrap);
    const bookSecure = <Typography variant="caption-default">{cms[238400]}</Typography>;

    return (
        <Box position={isMobileScreen ? 'relative' : 'absolute'} width="100%" zIndex={1} backgroundColor="feedback.notice">
            {/* eslint-disable-next-line @agoda/agoda-a11y/no-incorrect-props -- @agoda/agoda-a11y/no-incorrect-props[65c2fa80-0e82-48a3-9f9c-ba6643d53a1e] */}
            <Jacket
                title={cms[239364]}
                size="s"
                leadingIcon="fill.symbol.circle-check"
                variant="primary.notice"
                timer={bookSecure}
                data-testid="activities-card-highlight-banner"
            />
        </Box>
    );
};
ActivityCardHighlightBanner.displayName = 'ActivityCardHighlightBanner';

ActivityCardHighlightBanner.defaultProps = {
    isMobileScreen: false,
};

export default ActivityCardHighlightBanner;
